import styled from '@emotion/styled/macro'
import React from 'react'

export default function Divider({ text }) {
  return <Wrapper> {text} </Wrapper>
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: var(--text-white);
  ::before,
  ::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid var(--text-400);
  }

  :not(:empty)::before {
    margin-right: 0.5em;
  }

  :not(:empty)::after {
    margin-left: 0.5em;
  }
`
